
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class LavaFlowEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
        const curTime = time * 0.2 * config.parallaxSpeed;
        const complexity = config.parallaxComplexity || 1.0;
        const scale = config.parallaxScale || 1.0;
        
        ctx.fillStyle = pc.color;

        const draw = () => {
            const blobs = Math.floor(8 * complexity);
            for (let i = 0; i < blobs; i++) {
                const angle = i * (Math.PI * 2 / blobs) + curTime * (0.5 + i * 0.1);
                const x = Math.cos(angle) * width * 0.4;
                const y = Math.sin(angle * 0.5 + curTime) * height * 0.3;
                const r = (150 + Math.sin(curTime * 2 + i) * 50) * scale * (1 - layerIndex * 0.1);

                const grad = ctx.createRadialGradient(x, y, 0, x, y, r);
                grad.addColorStop(0, pc.color);
                grad.addColorStop(1, 'transparent');
                
                ctx.fillStyle = grad;
                ctx.beginPath();
                ctx.arc(x, y, r, 0, Math.PI * 2);
                ctx.fill();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
